import React from 'react';

type LabelProps = {
  children?: React.ReactNode;
  className?: string;
  htmlFor?: string;
};

const Label = ({ children, className, htmlFor }: LabelProps) => {
  return (
    <label
      className={`text-base font-normal text-neutral-800 font-open-sans ${className}`}
      htmlFor={htmlFor}
    >
      {children}
    </label>
  );
};

export default Label;
